import { render, staticRenderFns } from "./WidgetGame.vue?vue&type=template&id=6499c649&scoped=true&"
import script from "./WidgetGame.vue?vue&type=script&lang=ts&"
export * from "./WidgetGame.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetGame.vue?vue&type=style&index=0&id=6499c649&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6499c649",
  null
  
)

export default component.exports